import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@swyftx/aviary/atoms/Button';
import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';

import { SwyftxMarginAppHeaderTransfer } from 'src/lib/layout/SwyftxMarginAppShell/components';
import { useMarginAccount } from 'src/lib/margin/hooks/account';
import { useSwyftxMarginStore } from 'src/lib/margin/state';
import { useNavigateRoute } from 'src/lib/navigation/hooks';
import { NavigationURLs } from 'src/lib/navigation/types';

type Props = {
  hideTradeButton?: boolean;
  className?: string;
};

const MarginAccountSummaryActions: React.FC<Props> = ({ hideTradeButton, className }) => {
  const { isLoading } = useMarginAccount();
  const { navigate } = useNavigateRoute();
  const { tradeCurrency } = useSwyftxMarginStore();
  const { t } = useTranslation('margin');

  return (
    <FlexLayout alignItems='start' justifyContent='space-around' spacing={16} className={className}>
      <SwyftxMarginAppHeaderTransfer variant='filled' size='lg' className='w-full' />

      {!hideTradeButton && (
        <Button
          variant='outlined'
          disabled={isLoading}
          className='w-full'
          size='lg'
          onClick={() => navigate(NavigationURLs.MarginTradeAsset, { pathParams: { asset: tradeCurrency || 'BTC' } })}
        >
          {t('accountOverview.buttons.trade')}
        </Button>
      )}
    </FlexLayout>
  );
};

export { MarginAccountSummaryActions };
